module.exports = __webpack_public_path__ + "static/media/london-search.d08ebfcf.png";